import React from 'react';
import {Tooltip} from "@mui/material";

const CellShortenedName = ({value, numberOfCharacters}) => {

    const truncatedValue = value?.length > numberOfCharacters ? `${value?.substring(0, numberOfCharacters)}...` : value;

    return (
        <div>
            <Tooltip arrow placement="right" title={value}>
                <span
                    size="small"
                    sx={{minWidth: 'auto', marginLeft: 'auto'}}
                    color="error">
                   {truncatedValue}
                </span>
            </Tooltip>
        </div>
    );
};

export default CellShortenedName;